export default __webpack_public_path__ + "static/media/aErskine.32d2268f.png";